'use client'
import dynamic from 'next/dynamic'
import { useAudioRef } from '../context/AudioContext'
import Hero from '../components/Hero'

const Features = dynamic(() => import('../components/Features'))
const WhyLexoya = dynamic(() => import('../components/WhyLexoya'))
const CTA = dynamic(() => import('../components/CTA'))

export default function HomePage() {
  const audioStateRef = useAudioRef()

  return (
    <>
      <Hero audioStateRef={audioStateRef} />
      <Features />
      <WhyLexoya />
      <CTA />
    </>
  )
}
